import type { Discount } from '@types';
import { ProductDiscount } from './ProductDiscount';
import './style.scss';

type ProductPriceProps = {
  currency: string;
  amount?: number;
  discountAmount?: number;
  discount?: Discount;
};

const ProductPrice = ({
  currency, amount, discountAmount, discount,
}: ProductPriceProps) => (
  <div className="product-price">
    {!!discountAmount && discountAmount !== amount && (
      <div className="product-price__discount">
        {`${currency}${discountAmount?.toFixed(2)}`}
      </div>
    )}
    <div className="product-price__regular">
      {`${currency}${amount?.toFixed(2)}`}
    </div>
    {discount && <ProductDiscount discount={discount} />}
  </div>
);

export { ProductPrice };
